import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VCombobox,{attrs:{"items":_vm.items,"label":_vm.label,"outlined":_vm.outlined,"dense":_vm.dense,"item-text":"name","item-value":"id","hide-details":_vm.hideDetails,"clearable":_vm.clearable,"loading":_vm.loading,"rules":_vm.rules,"return-object":""},scopedSlots:_vm._u([{key:"item",fn:function(ref){
var on = ref.on;
var item = ref.item;
return [_c(VListItem,_vm._g({},on),[_c(VListItemContent,[_c(VListItemTitle,[_vm._v(_vm._s(item.name))]),_c(VListItemSubtitle,[_vm._v(_vm._s(item.yearFrom)+" - "+_vm._s(item.yearTo))])],1)],1)]}}]),model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})}
var staticRenderFns = []

export { render, staticRenderFns }